var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"d-title"},[_vm._v("接收消息地址")]),_c('p',[_vm._v(_vm._s(_vm.value.open_msg_notify_url || '无'))]),_c('p',{staticClass:"d-title"},[_vm._v("接收消息类型")]),_c('p',[_vm._v(_vm._s(_vm.topic.join(' | ')))])])}
var staticRenderFns = []

export { render, staticRenderFns }